export default "__VITE_ASSET__6432611d__"